<template>
  <div>
    <v-select
      v-model="education_stage_id"
      class="px-2"
      :items="educationStages"
      item-text="name"
      item-value="id"
      label="Segmentos"
      :disabled="educationStages.length === 0"
    >
      <template
        v-if="education_stage_id !== null"
        #append
      >
        <v-btn
          color="primary"
          text
          @click="education_stage_id = null"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-select>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
export default {
  mixins: [
    handlesServerValidation
  ],
  props: {
    educationSystemId: { type: Number, default: undefined },
    stageIdSelected: { type: Number, default: undefined }
  },
  data: () => ({
    educationStages: [],
    education_stage_id: null
  }),
  watch: {
    education_stage_id () {
      this.setEducationStage()
    },
    async educationSystemId () {
      if (this.educationSystemId) {
        await this.listEducationStages()
        this.educationStages.find(educationStage => educationStage.id === this.stageIdSelected) && (this.education_stage_id = this.stageIdSelected)
      } else {
        this.educationStages = []
        this.education_stage_id = null
        this.setEducationStage()
      }
    }
  },

  methods: {
    setEducationStage () {
      this.$emit('setEducationStage', this.education_stage_id)
    },
    async listEducationStages () {
      try {
        this.educationStages = await this.$api.listEducationStages(this.educationSystemId)
        this.education_stage_id = null
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter os segmentos, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
